// types/v3/cache.ts — cache contracts + key helpers (SPEC §3 / §5)

export interface CacheEntry<T> { version: string; fetchedAt: number; data: T }

export interface EntityCache {
  get<T>(key: string): Promise<CacheEntry<T> | undefined>
  set<T>(key: string, e: CacheEntry<T>): Promise<void>
  del(key: string): Promise<void>
  clearStore(storeId: string): Promise<void>
}

export type EntityName = 'settings' | 'products' | 'channel_price' | 'profile'

export const cacheKey = (storeId: string, e: EntityName) => `v3:${storeId}:${e}`
export const menuSetKey = (storeId: string, settingId: string) => `v3:${storeId}:menuSet:${settingId}`
export const cartKeyOf = (storeId: string, qrcodeId: string) => `${storeId}:${qrcodeId}`
